"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Control = require("./Control");

var _default = _Control.Control;
exports["default"] = _default;